// Started from shadcn/ui (new-york-v4) "label", restyled to Union. Short, sentence case
// ("Guest’s name"), above its control.

import { cn } from "@union/ui/lib/utils";
import { Label as LabelPrimitive } from "radix-ui";
import type * as React from "react";

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex select-none items-center gap-space-2 type-label text-foreground",
        "peer-disabled:cursor-not-allowed peer-disabled:text-faint-foreground",
        "group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-faint-foreground",
        className,
      )}
      {...props}
    />
  );
}

export { Label };
